import common from './common.json';
import home from './home.json';
import mypage from './mypage.json';
import comment from './comment.json';
import error from './error.json';
import work from './work.json';
import approval from './approval.json';

// 공통 번역(common)을 가장 뒤에 두어 덮어쓰기 방지
// 범위 번역(예. home)는 번역을 특정 키로 감싸서 사용하는 걸 권장
export default {
  ...mypage,
  ...home,
  ...comment,
  ...error,
  ...work,
  ...approval,
  ...common,
};
